<script setup lang="ts">
import { cookieConsentController, useCookieConsentDialogState } from '@/shared/lib';

import { CookieConsentPreferencesButtonTemplate } from './templates';

const { openPreferences } = useCookieConsentDialogState();
const { isChoiceRequired } = cookieConsentController;
</script>

<template>
  <CookieConsentPreferencesButtonTemplate
    v-if="!isChoiceRequired"
    @open="openPreferences"
  />
</template>
